import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["text", "copyIcon", "enable"];

  copy(event) {
    event.preventDefault();
    const text = this.textTarget;
    let textToCopy
    let copyIcon
    let button;
    if(this.hasCopyIconTarget) {
      button = this.copyIconTarget;
      copyIcon = this.copyIconTarget.firstElementChild;
    }

    // Check for unmasked value data attribute first (for encrypted fields)
    if (text.dataset.unmaskedValue) {
      textToCopy = text.dataset.unmaskedValue;
    } else if (text.tagName === 'INPUT' || text.tagName === 'TEXTAREA') {
      textToCopy = text.value;
    } else {
      textToCopy = text.textContent;
    }

    navigator.clipboard.writeText(textToCopy)
      .then(() => {
        // Anything gated on the copy (a "Done" button) comes on once the text is on the clipboard.
        this.enableTargets.forEach((target) => { target.disabled = false });

        if(this.hasCopyIconTarget) {
          const iconParent = copyIcon.parentNode; // Get the parent node of the icon
          iconParent.removeChild(copyIcon); // Remove the icon from the parent node
          iconParent.innerHTML += '<i class="fa-duotone fa-check text-success"></i>'; // Add the new icon back

          setTimeout(() => {
            const newCopyIcon = iconParent.querySelector(".fa-check"); // Select the new icon
            iconParent.removeChild(newCopyIcon); // Remove the new icon
            iconParent.innerHTML += '<i class="fa-duotone fa-clipboard gap-1"></i>'; // Add the original icon back
          }, 2000); // Reset the icon after 2 seconds
        }

        // Show tooltip
        if(button) {
          button.setAttribute('data-title', 'Copied!');
          button.classList.add('tooltip-visible');

          setTimeout(() => {
              button.setAttribute('data-title', '');
              button.classList.remove('tooltip-visible');
          }, 2000);
        }
      })
      .catch((error) => {
        console.error("Error copying link to clipboard:", error);
      });
  }
}
